<div class="relative">
    <img class="avatar flex items-center justify-center" [ngClass]="'user-border-color-'+user?.userColor" *ngIf="user?.picture?.small?.url" src="{{user?.picture?.small?.url}}"  />
    <div class="avatar flex items-center justify-center" [ngClass]="'user-border-color-'+user?.userColor" *ngIf="!user?.picture?.small?.url">{{renderShort(user)}}</div>
    <div class="user-online" *ngIf="user?.online"></div>
</div>

